import { IAction } from '../../interface/action/action.interface';

export function isActionInRoutes(action: IAction, routes: any[]): boolean {
  return routes.some((route) => (route.action && route.action.type === action.type) ||
    (route.actions && route.actions.some((currentAction) => currentAction.type === action)) ||
    (route.routes && isActionInRoutes(action, route.routes))
  );
}
